module.exports = __webpack_public_path__ + "media/images/icon__point--lost-cb10b8dddb753a59f73d66c2d7be1bcf.png";